import i18n from 'i18next';
import { call, put, takeEvery } from 'redux-saga/effects';
import { initialize, submit, submitFailure, submitSuccess, requestFailure, requestSuccess } from './actionCreators';
import { request } from '@wix/da-http-client/pkg/request';
import { pushConfirmationModal } from '../../Modals/redux/actionCreators';
function getFakeData() {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line global-require
        const fakeData = require('./fake');
        return fakeData;
    }
    return false;
}
function* handleInitialize(action) {
    const { deviationId } = action.payload;
    const result = yield call(request, {
        method: 'get',
        url: 'deviation/report/init',
        params: {
            deviationid: deviationId
        }
    }, getFakeData);
    if (result) {
        yield put(requestSuccess(deviationId, result));
    } else {
        yield put(requestFailure(deviationId));
    }
}
function* handleSubmit(action) {
    const { typeid, deviationId, answers } = action.payload;
    const result = yield call(request, {
        method: 'post',
        url: 'deviation/report/save',
        data: {
            typeid: typeid,
            deviationid: deviationId,
            answers: JSON.stringify(answers)
        }
    }, getFakeData);
    if (result) {
        yield put(submitSuccess(deviationId));
    } else {
        yield put(pushConfirmationModal({
            title: i18n.t('moderation.reportDeviation'),
            text: i18n.t('moderation.reportDeviationFail'),
            confirmBtnLabel: i18n.t('common.ok'),
            confirmBtnType: 'danger',
            withCancelButton: false
        }));
        yield put(submitFailure());
    }
}
function* handleSuccess(action) {
    yield put(pushConfirmationModal({
        title: i18n.t('moderation.reportDeviationSuccessTitle'),
        text: i18n.t('moderation.reportDeviationSuccess'),
        confirmBtnLabel: i18n.t('common.ok'),
        confirmBtnType: 'danger',
        withCancelButton: false
    }));
}
export default function* ReportPageModalRootSaga() {
    yield takeEvery(initialize, handleInitialize);
    yield takeEvery(submit, handleSubmit);
    yield takeEvery(submitSuccess, handleSuccess);
}
